__turbopack_context__.v({
  "currentPage": "Pagination-module__26JrhG__currentPage",
  "dealspage__pagination": "Pagination-module__26JrhG__dealspage__pagination",
  "firstDots": "Pagination-module__26JrhG__firstDots",
  "fullwidth": "Pagination-module__26JrhG__fullwidth",
  "lastDots": "Pagination-module__26JrhG__lastDots",
  "pagination": "Pagination-module__26JrhG__pagination",
  "paginationWithText": "Pagination-module__26JrhG__paginationWithText",
  "paginationWithoutText": "Pagination-module__26JrhG__paginationWithoutText",
});
